import { pick } from 'lodash';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

import type { VideoData } from 'bundles/item-lecture/types';

type VideoItemStore$DehydratedState = {
  itemId: string | null;
  videoData: VideoData | null;
  isLoading: boolean;
  hasError: boolean;
  errorMessage: string | null;
  loaded: boolean;
};

const SERIALIZED_PROPS = ['videoData', 'isLoading', 'hasError', 'errorMessage', 'loaded', 'itemId'] as const;

class VideoItemStore extends BaseStore implements VideoItemStore$DehydratedState {
  static storeName = 'VideoItemStore';

  static handlers = {
    LOAD_VIDEO_ITEM_START: 'onLoadVideoItemStart',
    LOAD_VIDEO_ITEM_SUCCESS: 'onLoadVideoItemSuccess',
    LOAD_VIDEO_ITEM_ERROR: 'onLoadVideoItemError',
  };

  itemId: string | null = null;

  videoData: VideoData | null = null;

  isLoading: boolean = false;

  hasError: boolean = false;

  errorMessage: string | null = null;

  loaded: boolean = false;

  declare emitChange: () => void;

  onLoadVideoItemStart() {
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = null;
    this.itemId = null;
    this.videoData = null;
    this.loaded = false;
    this.emitChange();
  }

  onLoadVideoItemSuccess({ itemId, videoData }: { itemId: string; videoData: VideoData }) {
    this.itemId = itemId;
    this.videoData = videoData;
    this.isLoading = false;
    this.hasError = false;
    this.errorMessage = null;
    this.loaded = true;
    this.emitChange();
  }

  onLoadVideoItemError({ errorMessage }: { errorMessage: string }) {
    this.isLoading = false;
    this.hasError = true;
    this.errorMessage = errorMessage;
    this.loaded = true;
    this.emitChange();
  }

  hasLoaded(): boolean {
    return this.loaded;
  }

  dehydrate(): VideoItemStore$DehydratedState {
    return pick(this, ...SERIALIZED_PROPS);
  }

  rehydrate(state: VideoItemStore$DehydratedState) {
    Object.assign(this, pick(state, ...SERIALIZED_PROPS));
  }
}

export default VideoItemStore;
